import { render, staticRenderFns } from "./productionCompanyForm.vue?vue&type=template&id=5059331b&"
import script from "./productionCompanyForm.vue?vue&type=script&lang=js&"
export * from "./productionCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./productionCompanyForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports